import FileData from '@/domain/FileData'

/**
 * メール送信キュー
 */
export class SendMailQueue {
    /** TO宛先 */
    to = ""
    /** CC宛先 */
    cc: string | null = null
    /** BCC宛先 */
    bcc: string | null = null
    /** REPLY TO  */
    replyTo: string | null = null
    /** 件名 */
    subject = ""
    /** 本文 */
    content = ""
    /** 添付ファイル */
    attachFiles: FileData[] = []

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SendMailQueue>) {
        Object.assign(this, init)
    }
}
